import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Trash, Plus, Minus, ShoppingCart } from 'lucide-react';
import axios from "axios";
import { product_uri } from '../../../../uri';
import { Spinner, useToast } from '@chakra-ui/react';
import { AuthContext } from '../../../../context/auth';
import { baseUrlLink } from '../../../../utils/type';

const CartItem = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const toast = useToast();
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCartItems();
  }, []);

  const fetchCartItems = async () => {
    try {
      setLoading(true);
      const res = await axios.get(product_uri + `/cart?user_id=${currentUser}`);
      setCartItems(res.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (err.response && err.response.status === 444) {
        navigate("/login");
      }
    }
  };

  const updateQuantity = async (itemId, newQuantity, stock) => {
    if (newQuantity < 1) return;

    // if (Number(newQuantity) < Number(stock.stock)) {
    //   toast({
    //     title: "Барааны үлдэгдэл хүрэлцэхгүй байна",
    //     description: `Зөвхөн ${stock.stock} ширхэг байна`,
    //     status: "warning",
    //     duration: 3000,
    //     isClosable: true,
    //   });
    //   return;
    // }
    
    try {
      setUpdating(true);
      const res = await axios.post(product_uri + `/cart/quantity?itemid=${itemId}&quantity=${newQuantity}`);
      if (res.status === 200) {
        setCartItems(cartItems.map(item => 
          item.id === itemId ? { ...item, quantity: newQuantity } : item
        ));
        toast({
          title: "Тоо хэмжээ шинэчлэгдлээ",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      }
      setUpdating(false);
    } catch (err) {
      console.log(err);
      setUpdating(false);
      toast({
        title: "Алдаа гарлаа",
        description: "Тоо хэмжээг шинэчлэхэд алдаа гарлаа",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const removeFromCart = async (itemId) => {
    try {
      setUpdating(true);
      const res = await axios.delete(product_uri + `/cart?itemid=${itemId}`);
      
      if (res.status === 200) {
        setCartItems(cartItems.filter(item => item.id !== itemId));
        toast({
          title: "Бараа сагснаас хасагдлаа",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      }
      setUpdating(false);
    } catch (err) {
      console.log(err);
      setUpdating(false);
      toast({
        title: "Алдаа гарлаа",
        description: "Барааг хасахад алдаа гарлаа",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      return total + (item.product.price * item.quantity);
    }, 0);
  };

  const proceedToCheckout = () => {
    navigate("/checkout");
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spinner size="xl" color="blue.500" />
      </div>
    );
  }

  return (
    <div className="mt-10">
      <div className="flex items-center mb-6">
        <ShoppingCart className="mr-2" />
        <h1 className="text-2xl font-bold">Сагсанд байгаа бараанууд</h1>
      </div>
      
      {cartItems.length === 0 ? (
        <div className="text-center py-10">
          <h2 className="text-xl mb-4">Таны сагс хоосон байна</h2>
          <Link to="/product" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-red-600">
            Худалдан авалт хийх
          </Link>
        </div>
      ) : (
        <>
          <div className="bg-gray-50 rounded-lg overflow-hidden shadow mb-6">
            {cartItems.map((item) => (
              <div key={item.id} className="flex flex-col md:flex-row border-b last:border-b-0 p-4 hover:bg-gray-100">
                <div className="md:w-24 h-24 mb-4 md:mb-0 flex-shrink-0">
                  <img 
                    src={baseUrlLink+item.product.images[0].url} 
                    alt={item.product.name}
                    className="w-full h-full object-cover rounded"
                  />
                </div>
                <div className="md:ml-4 flex-grow">
                  <div className="flex flex-col md:flex-row md:justify-between">
                    <div>
                      <h3 className="font-medium text-lg">{item.product.name}</h3>
                      <div className="text-sm text-gray-600 mt-1">
                        <span className="mr-4">Өнгө: {item?.color?.name}</span>
                        <span>Хэмжээ: {item?.size?.value}</span>
                      </div>
                      <div className="font-medium mt-1">{item.product.price.toLocaleString()}₮</div>
                    </div>
                    <div className="flex items-center mt-4 md:mt-0">
                      <button 
                        onClick={() => updateQuantity(item.id, item.quantity - 1, item.product)}
                        disabled={updating || item.quantity <= 1}
                        className="p-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
                      >
                        <Minus size={16} />
                      </button>
                      <span className="mx-3 w-8 text-center">{item.quantity}</span>
                      <button 
                        onClick={() => updateQuantity(item.id, item.quantity + 1, item.product)}
                        disabled={updating}
                        className="p-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
                      >
                        <Plus size={16} />
                      </button>
                      <button 
                        onClick={() => removeFromCart(item.id)}
                        disabled={updating}
                        className="ml-4 p-1 text-red-500 hover:text-red-700 disabled:opacity-50"
                      >
                        <Trash size={18} />
                      </button>
                    </div>
                  </div>
                  <div className="mt-2 text-right text-gray-700">
                    Нийт: {(item.product.price * item.quantity).toLocaleString()}₮
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="bg-gray-50 rounded-lg p-6 shadow">
            <div className="flex justify-between text-lg mb-4">
              <span>Дүн:</span>
              <span className="font-bold">{calculateTotal().toLocaleString()}₮</span>
            </div>
            <button 
              onClick={proceedToCheckout}
              className="w-full bg-red-600 text-white py-3 rounded-md font-medium hover:bg-red-700 transition"
            >
              Худалдан авах
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CartItem;